export default {
    "statusBar": {
        "fullscreenTitleEnter": "Vollbildmodus",
        "fullscreenTitleExit": "Volbildmodus verlassen",
        "networkActivity": "Netzwerk-Aktivität"
    }
};
